import { combineReducers } from 'redux';

// Reducers
import Store from './reducer';

const Reducers = combineReducers({
  Store: Store,
});
export default Reducers;
